export const ITEMS_PER_PAGE = 16;

/** The orders the list can be asked for; "default" is the site's own. */
export const GAME_SORTS = ["default", "name", "-name"] as const;
export type GameSort = (typeof GAME_SORTS)[number];

/** What each is called on the wire, where the site's own order is the empty string. */
export const SORT_PARAM: Record<GameSort, string> = { default: "", name: "name", "-name": "-name" };

/** How long the search waits after the last keystroke before it asks, in ms. */
export const SEARCH_DEBOUNCE_MS = 300;
/** The longest search the server takes. */
export const SEARCH_MAX_LENGTH = 50;
